// src/components/wellfinder/ShortcutHelp.jsx
//
// The `?` overlay, rendered from KEY_ACTIONS. Same rule as the map legend: the
// help and the handler read one source, so the help cannot describe a binding
// that does not exist.
//
// Not configurable. A remappable shortcut system is a support surface, and the
// map is eleven keys — small enough to learn in a minute, which is the actual
// requirement.
//
// Another page passes its own list (actions, groups), read from the same
// source as its own handler: the re-check page does (recheckKeys.js). Review
// passes nothing and gets KEY_ACTIONS.

import { KEY_ACTIONS, KEY_GROUPS } from "./adjudicationKeys";

export default function ShortcutHelp({ open, onClose, actions = KEY_ACTIONS, groups = KEY_GROUPS }) {
  if (!open) return null;
  return (
    <div
      data-testid="shortcut-help"
      className="absolute inset-0 z-20 flex items-center justify-center bg-bg/80 p-8"
      onClick={onClose}
    >
      <div
        className="max-h-full w-[34rem] overflow-auto rounded border border-bg-border bg-bg-soft p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-baseline justify-between">
          <h2 className="text-sm font-medium text-fg-primary">Keyboard</h2>
          <span className="text-[11px] text-fg-secondary">
            Esc or ? to close · keys are inert while typing a note
          </span>
        </div>
        {groups.map((group) => (
          <section key={group} className="mb-3 last:mb-0">
            <h3 className="mb-1 text-[10px] font-mono uppercase tracking-wide text-fg-secondary/70">
              {group}
            </h3>
            <ul className="space-y-1">
              {actions.filter((a) => a.group === group).map((a) => (
                <li key={a.id} className="flex min-w-0 items-baseline gap-2 text-xs">
                  <span className="flex w-24 shrink-0 gap-1">
                    {a.keys.map((k) => (
                      <kbd
                        key={k}
                        className="rounded border border-white/20 bg-white/[0.06] px-1 text-[10px] leading-4 text-fg-secondary"
                      >
                        {k}
                      </kbd>
                    ))}
                  </span>
                  <span className="min-w-0">
                    <span className={a.primary ? "text-accent-info" : "text-fg-primary"}>
                      {a.label}
                    </span>
                    {a.detail && (
                      <span className="block text-[11px] text-fg-secondary/70">{a.detail}</span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
